import React from 'react'
import styles from 'styles/layout/ReportCategoriesHeaderSection.module.sass'
import HeaderNavigation from '../header/HeaderNavigation'
import ReportCategoryHero from './ReportCategoryHero'
import ReportCategoryCarousel from './ReportCategoryCarousel'
//import ReportCategoryCarousel from './ReportCategoryCarousel'

/**
 * ReportCategoriesHeaderSection component renders the header section for report categories, including navigation,
 * a hero section, and a carousel displaying hot reports.
 *
 * @component
 *
 * @example
 * // Example usage:
 * import ReportCategoriesHeaderSection from './ReportCategoriesHeaderSection';
 *
 * const categories = [
 *   { id: '1', title: 'Market Insights', meta: { cover: 'image.jpg' }, description: 'Details about markets', topics: [] }
 * ];
 *
 * <ReportCategoriesHeaderSection />;
 *
 * @returns {JSX.Element} The rendered ReportCategoriesHeaderSection component.
 */
const ReportCategoriesHeaderSection: React.FC = () => {

    return (
        <section className={styles['report-categories-header-section']}>
            <div className={styles['main-wrapper']}>
                <HeaderNavigation theme='dark' />
                <div className={styles['background-container']}>
                    <ReportCategoryHero />
                    <ReportCategoryCarousel />
                </div>
            </div>
        </section>
    )
}

export default ReportCategoriesHeaderSection;